import { gql } from '@apollo/client';

export const NEW_POST_MUTATION = gql`
  mutation NewPost($message: String, $coverUrl: String, $audioUrl: String) {
    newPost(input: {
      message: $message,
      coverUrl: $coverUrl,
      audioUrl: $audioUrl
    }) {
      post {
        id
        message
        liked
        likesTotal
        cover {
          uri
        }
        audio {
          uri
        }
        author {
          id
          name
          avatar {
            uri
          }
        }
      }
    }
  }
`; 